import React from 'react';
import Pagination from 'react-ultimate-pagination-bootstrap-4';
import {duckify, filterDuck, singleDuck} from 'utils/duckify';
import {
  inSchoolPayments,
  customers,
  fields as fieldsDuck,
  exportableReportConfigs
} from 'ducks';
import withPagination from 'hocs/withPagination';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import queryString from 'query-string';
import { faSignOut } from '@fortawesome/pro-solid-svg-icons/faSignOut';
import Filters from 'components/Filters/Filters';

import './styles/LedgerItemList.scss';

import withFiltering from 'hocs/withFiltering';
import ContactList from 'components/ContactList/ContactList';
import DateFilter from '../shared/DateFilter';
import Placeholder from '../Placeholder';
import withDateFilter from '../../hocs/withDateFilter';
import BulkExportAction from '../ContactList/BulkActions/BulkExportAction';
import BulkActions from '../ContactList/BulkActions/BulkActions';
import BulkAction from '../ContactList/BulkActions/BulkAction';
import { makeReactColumns } from '../../utils/billingReports';

const InSchoolPayments = ({
  inSchoolPayments,
  customer,
  filters,
  additionalFields,
  page,
  setFilters,
  setPage,
  dateFilter,
  exportableReportConfigs
}) => {
  const { total, perPage } = inSchoolPayments;
  const totalPages = Math.ceil(total / perPage);
  const paymentMethods = Object.values(customer.payment_config.payment_methods)
    .map(m => [m.display_name, m.canonical_name]);
  paymentMethods.sort();

  let additionalColumns = [];
  let configColumns = [];

  if (inSchoolPayments.ready) {
    additionalColumns = inSchoolPayments.additionalFields.map(column => ({
      header: column.print_name,
      value: (item) => (
        <td
          className='contact-list-react-type'
          dangerouslySetInnerHTML={{ __html: item.additional_fields && item.additional_fields[column.canonical_name] }}
        />
      )
    }));
    configColumns = makeReactColumns(exportableReportConfigs.columns, additionalColumns);
  }

  return (
    <div key={JSON.stringify({
      filters, inSchoolPayments, page
    })}
    >
      <div className='ledger-title'>
        <div className='ledger-space-between'>
          <h2>In School Payments Report</h2>

          <BulkActions>
            <BulkAction title='Export' icon={faSignOut}>
              <BulkExportAction
                type='UserJobs::InSchoolPaymentReportJob'
                location={location}
                dateFilter={dateFilter}
                url='/api/in_school_payments/export.csv'
              />
              <BulkExportAction
                title='Export to PDF'
                type='UserJobs::InSchoolPaymentReportJob'
                location={location}
                dateFilter={dateFilter}
                url='/api/in_school_payments/export.pdf'
              />
            </BulkAction>
          </BulkActions>
        </div>

        {inSchoolPayments.ready && exportableReportConfigs.date_filter_label && (
          <DateFilter label={exportableReportConfigs.date_filter_label} dateFilter={dateFilter} />
        )}

        <div className='ledger-space-between'>
          <Filters
            fields={inSchoolPayments.ready ? exportableReportConfigs.filters.concat(additionalFields) : []}
            count={inSchoolPayments.ready ? inSchoolPayments.total : null}
            selected={filters}
            submitFilters={setFilters}
          />

          {totalPages > 1 && inSchoolPayments.ready && (
            <div>
              <div className='contact-list-react-pagination'>
                <div className='pagination pagination-right'>
                  <Pagination
                    currentPage={page}
                    totalPages={totalPages}
                    hideFirstAndLastPageLinks
                    onChange={setPage}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Placeholder.invisible ready={inSchoolPayments.ready}>
        <table className='table' />
      </Placeholder.invisible>

      <ContactList
        className={'ledger-item-list'}
        columns={configColumns}
        contacts={inSchoolPayments}
        emptyMessage='There are no payments matching the filters provided.'
        getSubRowContacts={(contact) => contact.billing_item_amounts}
      />
    </div>
  );
};

const mapDucksToProps = ({page, location, dateFilter}) => {
  return {
    customer: singleDuck(customers, 'current'),
    inSchoolPayments: filterDuck(inSchoolPayments, {
      ...dateFilter.queryParams,
      ...queryString.parse(location.search),
      page: page || 1
    }),
    additionalFields: filterDuck(fieldsDuck, {for: 'billing'}),
    exportableReportConfigs: singleDuck(exportableReportConfigs, 'in_school_payments')
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  ...props,
  setFilters: (newFilters) => {
    props.setFilters(newFilters);
    dispatch(inSchoolPayments.actions.markDirty());
  }
});

export default compose(
  withRouter,
  withFiltering,
  withPagination,
  withDateFilter(),
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(InSchoolPayments);
